module.exports = __webpack_public_path__ + "fonts/FixitIcons.4f765bc.eot";